require('./bootstrap');

import Vue from 'vue';
import Filters from './filters';
import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);
Vue.use(Filters);
Vue.use(require('vue-moment'));

new Vue({
    el: '#app',

    data() {
        return {
            tiny: null,
            states: null,
            loginReferral: null,
            theme: window.theme,
            consumerPortalNumbers: null,
            defaultConsumerPortalNumber: null
        };
    },

    mounted() {
        this.states = JSON.parse(window.states);
        this.loginReferral = window.login_referral;
        this.consumerPortalNumbers = JSON.parse(window.consumer_portal_numbers);
    },

    components: {
        App: require('./Home').default,
        LoginPage: require('./pages/Login').default,
        OffersPage: require('./pages/Offers').default,
        NotFoundPage: require('./pages/NotFound').default,
        NsfOffersPage: require('./pages/NsfOffers').default,
        EarlyPayoffPage: require('./pages/EarlyPayoff').default,
        EmailOptOutPage: require('./pages/EmailOptOut').default,
        SpecialOffersPage: require('./pages/SpecialOffers').default,
        CustomOffersPage: require('./pages/CustomOffers').default,
        FeedbackPage: require('./pages/Feedback').default,
        AccountDetailsPage: require('./pages/AccountDetails').default,
        EnterPaymentInformationPage: require('./pages/EnterPaymentInformation').default,
        SignaturePad: require('./components/SignaturePad').default,
        ContactRequestPage: require('./pages/ContactRequest').default,
        ECommunicationConsentPage: require('./pages/ECommunicationConsent').default,
        SmsConsentPage: require('./pages/SmsConsent.vue').default,
        AccountIneligiblePage: require('./pages/Ineligible').default,
        PaymentAuthorizationPage: require('./pages/PaymentAuthorization').default,
    },

    created() {
        this.$on('loading', () => this.$refs.app.toggleLoading());
        this.$on('confirm-offer', () => this.$refs.app.showOfferConfirm());
        this.$on('confirm-payment-information', () =>
            this.$refs.app.showPaymentConfirm()
        );
        this.$on('agreement', (confirmation) =>
            this.$refs.app.showAgreement(confirmation)
        );
        this.$on('confirm-email', (confirmation) =>
            this.$refs.app.showEmailConfirm(confirmation)
        );
        this.$on('prelit-status', (confirmation) =>
            this.$refs.app.showPrelitStatus(confirmation)
        );
        this.$on('account-details', (accountDetails) =>
            this.$refs.app.showAccountDetails(accountDetails)
        );
        this.$on('show-special-offer-popup', (accountId) =>
            this.$refs.app.showSpecialOfferPopUp(accountId)
        );
        this.$on('show-payment-reschedule', (reschedulePayment) =>
            this.$refs.app.showPaymentReschedule(reschedulePayment)
        );
        this.$on('show-early-payment', (earlyPayment) =>
            this.$refs.app.showEarlyPayment(earlyPayment)
        );
        this.$on('show-credit-report', (creditReport) =>
            this.$refs.app.showCreditReport(creditReport)
        );
        this.$on('select-account-for-login', (accounts) =>
            this.$refs.app.showAccountsSelectForLogin(accounts)
        );
        this.$on('select-account', (accounts) =>
            this.$refs.app.showAccountsSelect(accounts)
        );
        this.$on('update-billing-profile', (billingProfile) =>
            this.$refs.app.showUpdateBillingProfile(billingProfile)
        );
        this.$on('show-billing-profile-expiration-warning', (billingProfile) =>
            this.$refs.app.showBillingProfileExpirationWarning(billingProfile)
        );

        this.$on('set-mvn-template', (mvn) => this.$refs.app.setMvn(mvn));
        this.$on('show-mvn-template', () => this.$refs.app.showMvnTemplate());
    },

    methods: {
        /**
         * @param {Object} event
         * @return {void}
         */
        gtagEvent(event) {
            setTimeout(() => {
                if (typeof window.gtag !== 'undefined') {
                    console.log(event);
                    window.gtag('event', event, {
                        'event_category' : 'consumer-portal',
                    });
                }

                this.$http.post(`${this.$refs['app'].consumerPortalBaseUrl}/api/login-events`, {event: event});
            }, 500);
        },

        setDefaultConsumerPortalNumber(defaultConsumerPortalNumber) {
            this.defaultConsumerPortalNumber = defaultConsumerPortalNumber;
        },

        /**
         * Priority: {page}-{location} > {location} > {page} in that order...
         * @param location
         * @returns {*|null}
         */
        phoneNumberForLocation(location) {
            let numbers = this.consumerPortalNumbers;

            if (! numbers || ! Object.keys(numbers).length) {
                if (this.defaultConsumerPortalNumber) {
                    return this.defaultConsumerPortalNumber;
                } else {
                    return null;
                }
            }

            if (! this.$refs.app.consumerPortalPageName) {
                if (! numbers.hasOwnProperty(location)) return null;

                return numbers[location]; // location1
            } else {
                let locationWithPageName = `${this.$refs.app.consumerPortalPageName}-${location}`; // login-location1

                if (numbers.hasOwnProperty(locationWithPageName)) {
                    return numbers[locationWithPageName];
                }

                if (numbers.hasOwnProperty(location)) { // location1
                    return numbers[location];
                }

                if (numbers.hasOwnProperty(this.$refs.app.consumerPortalPageName)) { // login
                    return numbers[this.$refs.app.consumerPortalPageName];
                }

                if (this.$refs.app.consumerPortalNumber) {
                    return this.$refs.app.consumerPortalNumber;
                }
            }
        },
    }
});
